import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { sampleNewsList } from "../../Data/sampleNewsList";

const eventNames = {
  bdw: "BORDER DEFENSE WAR",
  jr: "DARK JURAID MOUNTAIN",
  cr: "COLLECTION RAGE",
  lw: "LUNAR WAR",
  csw: "CASTLE SIEGE WAR",
  bp: "BOSS PLACE EVENT",
  kk: "KILLER KNIGHT EVENT",
  hw: "HAT WINGS EVENT",
  9: "BI-FROST",
  10: "VS EVENT",
};

function MainContent() {
  const [activeEventTab, setActiveEventTab] = useState("bdw");
  const [activeNewsTab, setActiveNewsTab] = useState("hepsi");
  const [newsData, setNewsData] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
  // Son 5 veriyi al
  const lastFive = sampleNewsList.slice(-5);

  const grouped = lastFive.reduce((acc, item) => {
    acc["hepsi"] = [...(acc["hepsi"] || []), item];
    acc[item.type] = [...(acc[item.type] || []), item];
    return acc;
  }, {});

  setNewsData(grouped);
}, []);

  return (
    <div className="col-xs-12 col-sm-12 col-md-8">
      <div className="row">
        {/* ETKİNLİKLER */}
        <div className="col-xs-12">
          <div className="block">
            <div className="header">
              <h3>{t("etkinlikler")}</h3>
              <div className="header-right">
                <ul>
                  <li>
                    <Link to="/event-awards">{t("tümEtkinlik")}</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="event-counter">
              {/* Event içerikleri */}
              {Object.keys(eventNames).map((id, index) => (
                <div
                  key={id}
                  id={`event-${id}`}
                  className="eventcontent"
                  style={{ display: activeEventTab === id ? "block" : "none" }}>
                  <h1>{eventNames[id]}</h1>
                  <div className="counter">
                    <p>Süre</p>
                    <p>00:00:00</p>
                    <p className={index % 2 === 0 ? "pasif" : "aktif"}>
                      {index % 2 === 0 ? "KAPALI" : "AKTiF"}
                    </p>
                  </div>
                </div>
              ))}

              {/* Tablar */}
              <ul>
                {Object.keys(eventNames).map((id, i) => (
                  <li key={id}>
                    <a href="#!" role="button"
                      className="ectablink"
                      style={{
                        backgroundColor: activeEventTab === id ? "#a21b1b" : "",
                        cursor: "pointer",
                      }}
                      onClick={() => setActiveEventTab(id)}>
                      {String(i + 1).padStart(2, "0")}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* HABERLER */}
        <div className="col-xs-12">
          <div className="block">
            <div className="header">
              <h3>{t("haberler")}</h3>
              <div className="header-right">
                <ul>
                  {Object.keys(newsData).map((tab) => (
                    <li key={tab}>
                      <a href="#!" role="button"
                        className="tablink"
                        style={{
                          backgroundColor:
                            activeNewsTab === tab ? "#00000080" : "",
                          cursor: "pointer",
                        }}
                        onClick={() => setActiveNewsTab(tab)}>
                        {tab.toUpperCase()}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Seçilen haber içeriği */}
            <ul id={activeNewsTab} className="news">
              {newsData[activeNewsTab]?.map((news, i) => (
                <li key={i}>
                  <div className="news_left_column">
                    <h2>
                      <a href="#!">{news.title}</a>
                    </h2>
                    <h4>
                      <a href="#!" role="button" className={news.type}>
                        [{news.type.toUpperCase()}]
                      </a>{" "}
                      {news.date}
                    </h4>
                  </div>
                  <div className="news_right_column">
                    <Link className="news_read" to={`/news/${news.id}`}>
                      {t("detaylar")}
                    </Link>
                  </div>
                  <div className="clear"></div>
                </li>
              ))}
              <li>
                <div className="news_tb">
                  <Link className="news_read" to="/news">
                    {t("tümüneBak")}
                  </Link>
                </div>
                <div className="clear"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainContent;
